import React, { useState } from "react"
import CardGroup from "react-bootstrap/CardGroup"
import Card from "react-bootstrap/Card"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Alert from "react-bootstrap/Alert"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"

import "./recipesCard.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHeart, faPlus } from "@fortawesome/free-solid-svg-icons"
import QuickView from "./QuickView"
import AddRecipe from "./AddRecipe"
import AddMealPlanner from "./AddMealPlanner"

function RecipesCards({ recipes, totalResults }) {
  //quickview
  const [show, setShow] = useState(false)
  const [quickRecipe, setQuickRecipe] = useState()
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  //addRecipe to favorites
  const [showAdd, setShowAdd] = useState(false)
  const [addedRecipe, setAddedRecipe] = useState()
  const handleCloseAdd = () => setShowAdd(false)
  const handleShowAdd = () => setShowAdd(true)

  // add recipe to Meal Planner
  const [showAddMealPlanner, setShowAddMealPlanner] = useState(false)
  const [addedRecipeMealPlanner, setAddedRecipeMealPlanner] = useState()
  const handleCloseAddMealPlanner = () => setShowAddMealPlanner(false)
  const handleShowAddMealPlanner = () => setShowAddMealPlanner(true)

  const renderTooltipMealP = (props) => (
    <Tooltip id='button-tooltip' {...props}>
      Add to Meal Planner
    </Tooltip>
  )
  const renderTooltipFav = (props) => (
    <Tooltip id='button-tooltip' {...props}>
      Add to favorites
    </Tooltip>
  )
  const getRecipe = (recipe) => {
    setQuickRecipe(recipe)
  }
  const addRecipe = (recipe) => {
    setAddedRecipe(recipe)
  }
  const addRecipeMealPlanner = (recipe) => {
    setAddedRecipeMealPlanner(recipe)
  }

  return (
    <>
      <div className='alerts-div'>
        <h1 className='mt-3 mr-2 recipes-title'>Recipes</h1>
        <Alert className='mt-2 alert text-center alert-inline '>
          {totalResults === 1
            ? totalResults + " recipe"
            : totalResults + " recipes"}
        </Alert>
      </div>

      <CardGroup className='cardGroup p-3'>
        <Row md={2} lg={3} className='Cards-row'>
          {recipes.map((recipe) => {
            return (
              <Card key={recipe.id} className='cardsContainer mt-3'>
                <Card.Img
                  variant='top'
                  src={recipe.image}
                  className='card-img'
                />
                <Card.Body className='card-body'>
                  <Card.Title>{recipe.title}</Card.Title>
                </Card.Body>
                <div className='card-footer d-flex justify-content-between'>
                  <Button
                    className='myBtn'
                    onClick={(e) => {
                      handleShow()
                      getRecipe(recipe)
                      e.currentTarget.blur()
                    }}>
                    Quick view
                  </Button>
                  <OverlayTrigger
                    placement='top'
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltipFav}>
                    <Button
                      className='myBtn'
                      onClick={(e) => {
                        addRecipe(recipe)
                        handleShowAdd()
                        e.currentTarget.blur()
                      }}>
                      <FontAwesomeIcon icon={faHeart} />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement='top'
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltipMealP}>
                    <Button
                      className='myBtn'
                      onClick={(e) => {
                        addRecipeMealPlanner(recipe)
                        handleShowAddMealPlanner()
                        e.currentTarget.blur()
                      }}>
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </OverlayTrigger>
                </div>
              </Card>
            )
          })}
        </Row>
      </CardGroup>
      {quickRecipe && (
        <QuickView
          show={show}
          showAddRecipe={setShowAdd}
          handleClose={handleClose}
          handleShowAdd={handleShowAdd}
          handleShowAddMeal={handleShowAddMealPlanner}
          recipe={quickRecipe}
          addRecipe={addRecipe}
          addRecipeMealPlanner={addRecipeMealPlanner}></QuickView>
      )}
      {addedRecipe && (
        <AddRecipe
          show={showAdd}
          handleClose={handleCloseAdd}
          recipe={addedRecipe}></AddRecipe>
      )}
      {addedRecipeMealPlanner && (
        <AddMealPlanner
          show={showAddMealPlanner}
          handleClose={handleCloseAddMealPlanner}
          recipe={addedRecipeMealPlanner}></AddMealPlanner>
      )}
    </>
  )
}

export default RecipesCards
